import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import { Popup } from 'components/molecules/popup'
import styled from 'styled-components'

export const StyledPopup = styled(Popup)`
  &#share-popup {
    overflow: hidden;
    height: fit-content;
    border-radius: 16px;
    ${MediaQueries.mbUp} {
      width: unset;
      max-width: 480px;
    }

    .share__content-wrapper {
      padding: 16px 16px 40px;
    }

    .close-button {
      top: 16px;
      right: 16px;
      width: 24px;
      height: 24px;
    }

    .social-links {
      display: flex;
      justify-content: space-between;
      padding: 24px 0 20px;

      .social-container {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;

        img {
          width: 40px;
          height: 40px;
        }

        p {
          padding-top: 12px;
        }
      }
    }

    .onclick-copy {
      display: flex;
      justify-content: space-between;
      padding: 16px;
      background-color: ${(props: ThemeProps) =>
        props.theme.mbColors.lightGray};
      border-radius: 16px;

      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }

  .header {
    padding: 16px;
    /* border-radius: 16px 16px 0 0; */
    background-color: ${(props: ThemeProps) => props.theme.mbColors.lightGray};
  }
`
